<template>
    <div class="font-medium"
         :class="{'text-green-500': rate > 0, 'text-red-500' : rate < 0 , 'text-gray-500' : !rate}"
    >
        {{ addPlus && rate > 0 ? '+' : '' }}{{ format(rate) }}
    </div>
</template>

<script>
import NumberFormatter from "../../js/partials/NumberFormatter";

export default {
    props: [
        'rate',
        'addPlus',
    ],
    data() {
		return {};
    },
    methods: {
        format(nr) {
            return this.compact
                ? NumberFormatter.formatCompactNumber(nr)
                : NumberFormatter.format(nr);
        },
    },
    computed: {
        compact() {
            return window.screen.width <= 600;
        }
    }
}
</script>
